const Dict = require(`nllib/src/dict`);

const dict_app_environment_join = new Dict({
    initType: `000`,
    initParameter: {
        '000': {
            entityDefine: {
                text: `text`,
                value: `value`
            },
            entityList: [

                //----------frontend------------------------------------------------------------------------------------

                //<editor-fold desc="frontend-distributor">
                {
                    environment: `local`,
                    appKey: `frontend-distributor`,
                    urlPrefix: `//alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-distributor`,
                    urlPrefix: `//alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-distributor`,
                    urlPrefix: `//beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-distributor`,
                    urlPrefix: `//b.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-distributor`,
                    urlPrefix: `//omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-platform">
                {
                    environment: `local`,
                    appKey: `frontend-platform`,
                    urlPrefix: `//platform-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-platform`,
                    urlPrefix: `//platform-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-platform`,
                    urlPrefix: `//platform-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-platform`,
                    urlPrefix: `//platform.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-platform`,
                    urlPrefix: `//platform-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-supplier">
                {
                    environment: `local`,
                    appKey: `frontend-supplier`,
                    urlPrefix: `//supplier-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-supplier`,
                    urlPrefix: `//supplier-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-supplier`,
                    urlPrefix: `//supplier-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-supplier`,
                    urlPrefix: `//supplier.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-supplier`,
                    urlPrefix: `//supplier-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-hangsitehui-buyer">
                {
                    environment: `local`,
                    appKey: `frontend-hangsitehui-buyer`,
                    urlPrefix: `//hangsitehui-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-hangsitehui-buyer`,
                    urlPrefix: `//hangsitehui-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-hangsitehui-buyer`,
                    urlPrefix: `//hangsitehui-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-hangsitehui-buyer`,
                    urlPrefix: `//hangsitehui.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-hangsitehui-buyer`,
                    urlPrefix: `//hangsitehui-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-hangsitehui-platform">
                {
                    environment: `local`,
                    appKey: `frontend-hangsitehui-platform`,
                    urlPrefix: `//hsth-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-hangsitehui-platform`,
                    urlPrefix: `//hsth-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-hangsitehui-platform`,
                    urlPrefix: `//hsth-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-hangsitehui-platform`,
                    urlPrefix: `//hsth.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-hangsitehui-platform`,
                    urlPrefix: `//hsth-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-hangsitehui-airline">
                {
                    environment: `local`,
                    appKey: `frontend-hangsitehui-airline`,
                    urlPrefix: `//hangsitehui-airline-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-hangsitehui-airline`,
                    urlPrefix: `//hangsitehui-airline-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-hangsitehui-airline`,
                    urlPrefix: `//hangsitehui-airline-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-hangsitehui-airline`,
                    urlPrefix: `//hangsitehui-airline.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-hangsitehui-airline`,
                    urlPrefix: `//hangsitehui-airline-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-hangsitehui-agent">
                {
                    environment: `local`,
                    appKey: `frontend-hangsitehui-agent`,
                    urlPrefix: `//hangsitehui-agent-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-hangsitehui-agent`,
                    urlPrefix: `//hangsitehui-agent-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-hangsitehui-agent`,
                    urlPrefix: `//hangsitehui-agent-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-hangsitehui-agent`,
                    urlPrefix: `//hangsitehui-agent.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-hangsitehui-agent`,
                    urlPrefix: `//hangsitehui-agent-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-b2c-mall">
                {
                    environment: `local`,
                    appKey: `frontend-b2c-mall`,
                    urlPrefix: `//b2c-mall-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-b2c-mall`,
                    urlPrefix: `//b2c-mall-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-b2c-mall`,
                    urlPrefix: `//b2c-mall-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-b2c-mall`,
                    urlPrefix: `//b2c-mall.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-b2c-mall`,
                    urlPrefix: `//b2c-mall-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-b2c-admin">
                {
                    environment: `local`,
                    appKey: `frontend-b2c-admin`,
                    urlPrefix: `//b2c-admin-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-b2c-admin`,
                    urlPrefix: `//b2c-admin-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-b2c-admin`,
                    urlPrefix: `//b2c-admin-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-b2c-admin`,
                    urlPrefix: `//b2c-admin.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-b2c-admin`,
                    urlPrefix: `//b2c-admin-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-haolv-enterprise">
                {
                    environment: `local`,
                    appKey: `frontend-haolv-enterprise`,
                    urlPrefix: `//alpha.haolvtrip.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-haolv-enterprise`,
                    urlPrefix: `//alpha.haolvtrip.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-haolv-enterprise`,
                    urlPrefix: `//beta.haolvtrip.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-haolv-enterprise`,
                    urlPrefix: `//www.haolvtrip.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-haolv-enterprise`,
                    urlPrefix: `//omega.haolvtrip.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-haolv-enterprise-app">
                {
                    environment: `local`,
                    appKey: `frontend-haolv-enterprise-app`,
                    urlPrefix: `//haolv-enterprise-app-alpha.haolvtrip.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-haolv-enterprise-app`,
                    urlPrefix: `//haolv-enterprise-app-alpha.haolvtrip.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-haolv-enterprise-app`,
                    urlPrefix: `//haolv-enterprise-app-beta.haolvtrip.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-haolv-enterprise-app`,
                    urlPrefix: `//haolv-enterprise-app.haolvtrip.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-haolv-enterprise-app`,
                    urlPrefix: `//haolv-enterprise-app-omega.haolvtrip.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-haolv-platform">
                {
                    environment: `local`,
                    appKey: `frontend-haolv-platform`,
                    urlPrefix: `//platform-alpha.haolvtrip.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-haolv-platform`,
                    urlPrefix: `//platform-alpha.haolvtrip.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-haolv-platform`,
                    urlPrefix: `//platform-beta.haolvtrip.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-haolv-platform`,
                    urlPrefix: `//platform.haolvtrip.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-haolv-platform`,
                    urlPrefix: `//platform-omega.haolvtrip.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-yinzhilv-finance">
                {
                    environment: `local`,
                    appKey: `frontend-yinzhilv-finance`,
                    urlPrefix: `//caiwu-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-yinzhilv-finance`,
                    urlPrefix: `//caiwu-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-yinzhilv-finance`,
                    urlPrefix: `//caiwu-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-yinzhilv-finance`,
                    urlPrefix: `//caiwu.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-yinzhilv-finance`,
                    urlPrefix: `//caiwu-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="frontend-yinzhilv-frontend-platform-flight">
                {
                    environment: `local`,
                    appKey: `frontend-yinzhilv-frontend-platform-flight`,
                    urlPrefix: `//kefu-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `frontend-yinzhilv-frontend-platform-flight`,
                    urlPrefix: `//kefu-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `frontend-yinzhilv-frontend-platform-flight`,
                    urlPrefix: `//kefu-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `frontend-yinzhilv-frontend-platform-flight`,
                    urlPrefix: `//kefu.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `frontend-yinzhilv-frontend-platform-flight`,
                    urlPrefix: `//kefu-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //----------backend-------------------------------------------------------------------------------------

                //<editor-fold desc="default">
                {
                    environment: `local`,
                    appKey: `default`,
                    urlPrefix: `//tour-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `default`,
                    urlPrefix: `//tour-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `default`,
                    urlPrefix: `//tour-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `default`,
                    urlPrefix: `//tour.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `default`,
                    urlPrefix: `//tour-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="hotel">
                {
                    environment: `local`,
                    appKey: `hotel`,
                    urlPrefix: `//219.128.52.2:9090`,
                },
                {
                    environment: `alpha`,
                    appKey: `hotel`,
                    urlPrefix: `//219.128.52.2:9090`,
                },
                {
                    environment: `beta`,
                    appKey: `hotel`,
                    urlPrefix: `//hoteltest.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `hotel`,
                    urlPrefix: `//hotel.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `hotel`,
                    urlPrefix: `//hotel-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="flight">
                {
                    environment: `local`,
                    appKey: `flight`,
                    urlPrefix: `//219.128.52.2:8989`,
                },
                {
                    environment: `alpha`,
                    appKey: `flight`,
                    urlPrefix: `//219.128.52.2:8989`,
                },
                {
                    environment: `beta`,
                    appKey: `flight`,
                    urlPrefix: `//flighttest.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `flight`,
                    urlPrefix: `//flight.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `flight`,
                    urlPrefix: `//flight-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="monitor">
                {
                    environment: `local`,
                    appKey: `monitor`,
                    urlPrefix: `//219.128.52.2:7799`,
                },
                {
                    environment: `alpha`,
                    appKey: `monitor`,
                    urlPrefix: `//219.128.52.2:7799`,
                },
                {
                    environment: `beta`,
                    appKey: `monitor`,
                    urlPrefix: `//monitortest.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `monitor`,
                    urlPrefix: `//monitor.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `monitor`,
                    urlPrefix: `//monitor-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="payment">
                {
                    environment: `local`,
                    appKey: `payment`,
                    urlPrefix: `//payment-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `payment`,
                    urlPrefix: `//payment-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `payment`,
                    urlPrefix: `//payment-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `payment`,
                    urlPrefix: `//payment.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `payment`,
                    urlPrefix: `//payment-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="wallet">
                {
                    environment: `local`,
                    appKey: `wallet`,
                    // urlPrefix: `//219.128.52.2:7777`,
                    urlPrefix: `//219.128.52.2:18001`,
                },
                {
                    environment: `alpha`,
                    appKey: `wallet`,
                    // urlPrefix: `//219.128.52.2:7777`,
                    urlPrefix: `//219.128.52.2:18001`,
                },
                {
                    environment: `beta`,
                    appKey: `wallet`,
                    urlPrefix: `//wallettest.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `wallet`,
                    urlPrefix: `//wallet.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `wallet`,
                    urlPrefix: `//wallet-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="trains">
                {
                    environment: `local`,
                    appKey: `trains`,
                    urlPrefix: `//219.128.52.2:9900`,
                },
                {
                    environment: `alpha`,
                    appKey: `trains`,
                    urlPrefix: `//219.128.52.2:9900`,
                },
                {
                    environment: `beta`,
                    appKey: `trains`,
                    urlPrefix: `//traintest.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `trains`,
                    urlPrefix: `//train.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `trains`,
                    urlPrefix: `//train-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="longcunguan">
                {
                    environment: `local`,
                    appKey: `longcunguan`,
                    urlPrefix: `https://lcg.murongtech.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `longcunguan`,
                    urlPrefix: `https://lcg.murongtech.com`,
                },
                {
                    environment: `beta`,
                    appKey: `longcunguan`,
                    urlPrefix: `https://lcg.murongtech.com`,
                },
                {
                    environment: `release`,
                    appKey: `longcunguan`,
                    urlPrefix: `https://lcg.ccb.com`,
                },
                {
                    environment: `omega`,
                    appKey: `longcunguan`,
                    urlPrefix: `https://lcg.murongtech.com`,
                },
                //</editor-fold>

                //<editor-fold desc="UnionPay-b2b">
                {
                    environment: `local`,
                    appKey: `UnionPay-b2b`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `alpha`,
                    appKey: `UnionPay-b2b`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `beta`,
                    appKey: `UnionPay-b2b`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `release`,
                    appKey: `UnionPay-b2b`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `omega`,
                    appKey: `UnionPay-b2b`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                //</editor-fold>

                //<editor-fold desc="UnionPay-b2c">
                {
                    environment: `local`,
                    appKey: `UnionPay-b2c`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `alpha`,
                    appKey: `UnionPay-b2c`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `beta`,
                    appKey: `UnionPay-b2c`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `release`,
                    appKey: `UnionPay-b2c`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                {
                    environment: `omega`,
                    appKey: `UnionPay-b2c`,
                    urlPrefix: `https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0`,
                },
                //</editor-fold>

                //<editor-fold desc="haolv-default">
                {
                    environment: `local`,
                    appKey: `haolv-default`,
                    urlPrefix: `//api-alpha.haolvtrip.com`,
                    // urlPrefix: `//192.168.0.13:8765`,//孙万豪
                    // urlPrefix: `//192.168.0.19:8765`,//朱振生
                    // urlPrefix: `//192.168.0.17:8765`,//赵先富
                },
                {
                    environment: `alpha`,
                    appKey: `haolv-default`,
                    urlPrefix: `//api-alpha.haolvtrip.com`,
                },
                {
                    environment: `beta`,
                    appKey: `haolv-default`,
                    urlPrefix: `//api-beta.haolvtrip.com`,
                },
                {
                    environment: `release`,
                    appKey: `haolv-default`,
                    urlPrefix: `//api.haolvtrip.com`,
                },
                {
                    environment: `omega`,
                    appKey: `haolv-default`,
                    urlPrefix: `//api-omega.haolvtrip.com`,
                },
                //</editor-fold>

                //<editor-fold desc="hangsitehui-default">
                {
                    environment: `local`,
                    appKey: `hangsitehui-default`,
                    urlPrefix: `//hangsitehui-api-alpha.yinzhilv.com`,
                    // urlPrefix: `//192.168.0.14:8988`,//卢惠
                },
                {
                    environment: `alpha`,
                    appKey: `hangsitehui-default`,
                    urlPrefix: `//hangsitehui-api-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `hangsitehui-default`,
                    urlPrefix: `//hangsitehui-api-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `hangsitehui-default`,
                    urlPrefix: `//hangsitehui-api-release.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `hangsitehui-default`,
                    urlPrefix: `//hangsitehui-api-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="statistics">
                {
                    environment: `local`,
                    appKey: `statistics`,
                    urlPrefix: `//statistics-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `statistics`,
                    urlPrefix: `//statistics-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `statistics`,
                    urlPrefix: `//statistics-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `statistics`,
                    urlPrefix: `//statistics.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `statistics`,
                    urlPrefix: `//statistics-beta.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="b2c">
                {
                    environment: `local`,
                    appKey: `b2c`,
                    urlPrefix: `//b2c-api-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `b2c`,
                    urlPrefix: `//b2c-api-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `b2c`,
                    urlPrefix: `//b2c-api-beta.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `b2c`,
                    urlPrefix: `//b2c-api.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `b2c`,
                    urlPrefix: `//b2c-api-omega.yinzhilv.com`,
                },
                //</editor-fold>

                //<editor-fold desc="yinzhilv-temporary-storage-system">
                {
                    environment: `local`,
                    appKey: `yinzhilv-temporary-storage-system`,
                    urlPrefix: `//s-alpha.yinzhilv.com`,
                },
                {
                    environment: `alpha`,
                    appKey: `yinzhilv-temporary-storage-system`,
                    urlPrefix: `//s-alpha.yinzhilv.com`,
                },
                {
                    environment: `beta`,
                    appKey: `yinzhilv-temporary-storage-system`,
                    urlPrefix: `//s-alpha.yinzhilv.com`,
                },
                {
                    environment: `release`,
                    appKey: `yinzhilv-temporary-storage-system`,
                    urlPrefix: `//s.yinzhilv.com`,
                },
                {
                    environment: `omega`,
                    appKey: `yinzhilv-temporary-storage-system`,
                    urlPrefix: `//s-alpha.yinzhilv.com`,
                },
                //</editor-fold>
            ]
        }
    }
});

console.log(dict_app_environment_join);

module.exports = dict_app_environment_join;
